import React, { useState, useEffect, createContext } from 'react';
import { navigate } from 'gatsby';

const { languages } = require('../util/data/languages');

const defaultLang = languages.en;
const GlobalContext = createContext(null);

const isHome = (pathname) => {
  return (
    pathname === '/' ||
    Object.keys(languages).some(
      (key) =>
        pathname === `/${languages[key]}` || pathname === `/${languages[key]}/`
    )
  );
};

const Provider = ({ children }) => {
  const [menu, setMenu] = useState([]);
  const [language, setLanguage] = useState('');
  const [translations, setTranslations] = useState([]);

  useEffect(() => {
    const localLang = localStorage.getItem('language');
    if (
      language &&
      localLang &&
      localLang !== language &&
      isHome(window.location.pathname)
    ) {
      localLang === defaultLang ? navigate(`/`) : navigate(`/${localLang}/`);
    }
  }, [language]);

  return (
    <GlobalContext.Provider
      value={{
        language,
        menu,
        translations,
        setLanguage,
        setMenu,
        setTranslations,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

const GlobalProvider = ({ element }) => <Provider>{element}</Provider>;

export { GlobalContext, GlobalProvider };
